import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpCachingIntercepttor } from './http-caching-interceptor';
import { HttpCustomerHeaderInterceptor } from './http-custom-header-interceptor';
import { AuthInterceptor } from './auth.interceptor';

export const HTTP_INTERCEPTORS_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpCustomerHeaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpCachingIntercepttor, multi: true },
];
